import { Clock, Send, CheckCircle2 } from "lucide-react";

// Appeal countdown chip: when a confirmed case will be escalated to 2K (after the dispute window).
export const DispatchCountdown = ({ status }) => {
  if (!status) return null;
  const base = "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold";
  if (status.state === "sent") {
    return (
      <span data-testid="dispatch-countdown" className={`${base} border border-[#00FF87]/40 bg-[#00FF87]/10 text-[#4ADE80]`}>
        <CheckCircle2 size={12} /> Sent to 2K · {new Date(status.at).toLocaleDateString()}
      </span>
    );
  }
  if (status.state === "due") {
    return (
      <span data-testid="dispatch-countdown" title="Dispute window elapsed — goes out in the next daily digest."
        className={`${base} border border-[#00F0FF]/40 bg-[#00F0FF]/10 text-[#00F0FF]`}>
        <Send size={12} /> Sending to 2K within 24h
      </span>
    );
  }
  return (
    <span data-testid="dispatch-countdown" title={`Escalates to 2K after a ${status.window_days}-day appeal window (around ${new Date(status.send_after).toLocaleDateString()}).`}
      className={`${base} border border-[#F97316]/40 bg-[#F97316]/10 text-[#FDBA74]`}>
      <Clock size={12} /> Sends to 2K in {status.days_left}d
    </span>
  );
};
